import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SHIPMENTS_OPEN_BATCHES_PATH } from '../../../../../services/batch-grid-service';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const AutoShipFBAError = ({ batchID, batchNumber }) => {
  const linkToBatch = `${SHIPMENTS_OPEN_BATCHES_PATH}/${batchID}`;
  return (
    <React.Fragment>
      <FormattedMessage
        defaultMessage='An error was encountered while processing Batch <l>{batchNumber}</l>. This Batch was created because of an automation rule.'
        description='Auto FBA batch alert'
        id='jxPf4U'
        values={{
          batchNumber,
          l: (chunks) => <Link to={linkToBatch}>{chunks}</Link>,
        }}
      />
    </React.Fragment>
  );
};

AutoShipFBAError.propTypes = {
  batchID: PropTypes.number.isRequired,
  batchNumber: PropTypes.string.isRequired,
};

export const AutoShipFbaError = injectIntl(AutoShipFBAError);
